/* unplugin-vue-components disabled */import { render } from "./emailpdf.vue?vue&type=template&id=49d38225&scoped=true"
import script from "./emailpdf.vue?vue&type=script&lang=js"
export * from "./emailpdf.vue?vue&type=script&lang=js"

import "./emailpdf.vue?vue&type=style&index=0&id=49d38225&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d38225"]])

export default __exports__